import { useEffect } from 'react';
import samplesSelectorModel from '@/components/Samples/SamplesSelector/SamplesSelectorModel';
import { useSearchParams } from 'next/navigation';
import { useManagerEntity } from '@/shared/managerHelpers';
import etaLoader from '@/lib/EtaLoader';

// select sample if in url we have somethine like this:
// practice?m=ID
// or 
// play?m=ID
export function useSampleSelection() {
  const searchParams = useSearchParams()
  const sampleId = searchParams.get('m')
  const manager = useManagerEntity();

  useEffect(() => {
    if (sampleId) {
      // Clear any previous error state when attempting to load a new sample
      if (etaLoader.hasError) {
        etaLoader.clearError();
      }

      samplesSelectorModel.selectSample(sampleId);
    }
  }, [sampleId, manager]);
} 